const e = /* @__PURE__ */ Symbol("ElSelectGroup"), l = /* @__PURE__ */ Symbol("ElSelect");
export {
  e as selectGroupKey,
  l as selectKey
};
